import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DocumentMarkdownContent } from '../components/document/DocumentMarkdownContent';
import { DocumentViewHeader } from '../components/document/DocumentViewHeader';
import { useDocumentView } from '../hooks/useDocumentView';

export default function DocumentViewPage() {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const { document, loading, error } = useDocumentView(documentId);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-12 h-12 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background p-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted-foreground hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Retour</span>
        </button>
        <div className="text-center py-12">
          <p className="text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="document-view-page" className="min-h-screen bg-background">
      <DocumentViewHeader document={document} onBack={() => navigate(-1)} />

      <div className="mx-auto max-w-4xl p-6">
        <DocumentMarkdownContent content={document.content} />
      </div>
    </div>
  );
}
